import { ArrowDown } from "lucide-react";
import { IMAGES, BRAND } from "@/lib/siteData";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative w-full h-[88vh] min-h-[600px] overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.heroPrimary}
          alt="Mango-leaf garlands hanging beneath the maroon ceiling at Sri Bhavani Kalyana Mandira"
          className="w-full h-full object-cover hero-pan"
          loading="eager"
          data-testid="hero-image"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground/40 via-foreground/25 to-foreground/65" />
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col justify-end pb-20 md:pb-28">
        <div className="max-w-3xl text-background">
          <p className="eyebrow mb-6 fade-up" style={{ color: "hsl(var(--secondary))" }} data-testid="hero-overline">
            Bhavani Kalyana Mandira · {BRAND.location}
          </p>
          <h1
            className="font-headings text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-background fade-up fade-up-delay-1"
            data-testid="hero-headline"
          >
            Where Tradition Meets Celebration in the Heart of South Bangalore.
          </h1>
          <p
            className="mt-6 max-w-2xl text-base md:text-lg text-background/85 font-body leading-relaxed fade-up fade-up-delay-2"
            data-testid="hero-subheadline"
          >
            Welcome to Sri Bhavani Kalyana Mandira — a timeless wedding venue and event hall in Basavanagudi, tailored for unforgettable marriages, engagements and family milestones.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4 fade-up fade-up-delay-3">
            <button
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center px-7 py-3.5 rounded-sm bg-primary text-primary-foreground font-ui text-[12px] uppercase tracking-[0.22em] hover:bg-primary/90 transition-colors"
              data-testid="hero-cta-check-availability"
            >
              Check Availability
            </button>
            <button
              onClick={() => scrollTo("events")}
              className="inline-flex items-center px-7 py-3.5 rounded-sm border border-background/70 text-background font-ui text-[12px] uppercase tracking-[0.22em] hover:bg-background hover:text-foreground transition-colors"
              data-testid="hero-cta-explore-events"
            >
              Explore Events
            </button>
          </div>
        </div>

        <button
          onClick={() => scrollTo("welcome")}
          className="absolute bottom-6 right-6 md:right-10 text-background/80 hover:text-secondary transition-colors flex items-center gap-2 font-ui text-[11px] uppercase tracking-[0.22em]"
          aria-label="Scroll to next section"
          data-testid="hero-scroll-indicator"
        >
          Scroll <ArrowDown size={16} className="animate-bounce" />
        </button>
      </div>
    </section>
  );
}
